import televisonAndFilm from '../../../../images/discovery/demographics/audience-interests-icons/television-and-film.svg';
import music from '../../../../images/discovery/demographics/audience-interests-icons/music.svg';
import shoppingAndRetail from '../../../../images/discovery/demographics/audience-interests-icons/shopping-and-retail.svg';
import coffeeTeaAndBeverages from '../../../../images/discovery/demographics/audience-interests-icons/coffee-tea-and-beverages.svg';
import cameraAndPhotography from '../../../../images/discovery/demographics/audience-interests-icons/camera-and-photography.svg';
import clothesShoesHandbagsAccessories from '../../../../images/discovery/demographics/audience-interests-icons/clothes-shoes-handbags-accessories.svg';
import beerWineAndSpirits from '../../../../images/discovery/demographics/audience-interests-icons/beer-wine-and-spirits.svg';
import sports from '../../../../images/discovery/demographics/audience-interests-icons/sports.svg';
import electronicsAndComputers from '../../../../images/discovery/demographics/audience-interests-icons/electronics-and-computers.svg';
import gaming from '../../../../images/discovery/demographics/audience-interests-icons/gaming.svg';
import activewear from '../../../../images/discovery/demographics/audience-interests-icons/activewear.svg';
import artAndDesign from '../../../../images/discovery/demographics/audience-interests-icons/art-and-design.svg';
import travelTourismAndAviation from '../../../../images/discovery/demographics/audience-interests-icons/travel-tourism-and-aviation.svg';
import businessAndCareers from '../../../../images/discovery/demographics/audience-interests-icons/business-and-careers.svg';
import beautyAndCosmetics from '../../../../images/discovery/demographics/audience-interests-icons/beauty-and-cosmetics.svg';
import healthcareAndMedicine from '../../../../images/discovery/demographics/audience-interests-icons/healthcare-and-medicine.svg';
import jewelleryAndWatches from '../../../../images/discovery/demographics/audience-interests-icons/jewellery-and-watches.svg';
import restaurantsFoodAndGrocery from '../../../../images/discovery/demographics/audience-interests-icons/restaurants-food-and-grocery.svg';
import toysChildrenAndBaby from '../../../../images/discovery/demographics/audience-interests-icons/toys-children-and-baby.svg';
import fitnessAndYoga from '../../../../images/discovery/demographics/audience-interests-icons/fitness-and-yoga.svg';
import wedding from '../../../../images/discovery/demographics/audience-interests-icons/wedding.svg';
import tobaccoAndSmoking from '../../../../images/discovery/demographics/audience-interests-icons/tobacco-and-smoking.svg';
import pets from '../../../../images/discovery/demographics/audience-interests-icons/pets.svg';
import healthyLifestyle from '../../../../images/discovery/demographics/audience-interests-icons/healthy-lifestyle.svg';
import luxuryGoods from '../../../../images/discovery/demographics/audience-interests-icons/luxury-goods.svg';
import homeDecorFurnitureAndGarden from '../../../../images/discovery/demographics/audience-interests-icons/home-decor-furniture-and-garden.svg';
import friendsFamilyAndRelationships from '../../../../images/discovery/demographics/audience-interests-icons/friends-family-and-relationships.svg';
import carsAndMotorbikes from '../../../../images/discovery/demographics/audience-interests-icons/cars-and-motorbikes.svg';

import '../styles/audienceTopInterests.scss';

export default function AudienceTopInterests({ audienceTopInterestsData }) {
  if (!audienceTopInterestsData || audienceTopInterestsData?.length === 0) {
    return null;
  }
  return (
    <div className="demographics-card">
      <h2>Audience Top Interests</h2>
      <div className="audience-intereset-container">
        {audienceTopInterestsData &&
          audienceTopInterestsData.slice(0, 5).map((d, i) => <StatCard key={d.id} {...d} index={i} />)}
      </div>
    </div>
  );
}

const StatCard = ({ name, weight, index }) => {
  const iconName = interestTypes[index];
  return (
    <div className="stat-card">
      <p className="title">
        <img src={iconName} alt={name} />
        {name}
      </p>
      <p className="value">{(weight * 100).toFixed(2)}%</p>
    </div>
  );
};

const interestTypes = [
  televisonAndFilm,
  music,
  shoppingAndRetail,
  coffeeTeaAndBeverages,
  cameraAndPhotography,
  clothesShoesHandbagsAccessories,
  beerWineAndSpirits,
  sports,
  electronicsAndComputers,
  gaming,
  activewear,
  artAndDesign,
  travelTourismAndAviation,
  businessAndCareers,
  beautyAndCosmetics,
  healthcareAndMedicine,
  jewelleryAndWatches,
  restaurantsFoodAndGrocery,
  toysChildrenAndBaby,
  fitnessAndYoga,
  wedding,
  tobaccoAndSmoking,
  pets,
  healthyLifestyle,
  luxuryGoods,
  homeDecorFurnitureAndGarden,
  friendsFamilyAndRelationships,
  carsAndMotorbikes,
];
